<template>
    <v-list-tile>
            <AutocompleteCollege 
                class="ml-4"      
                style="width: 90%; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"          
                :prepend="'account_balance'" 
                v-on:return-selection="changeHandler" />
    </v-list-tile>

</template>

<script>
    import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
    import AutocompleteCollege from '@/components/forms/AutocompleteCollege.vue'

    export default {

        components: { AutocompleteCollege },

        methods: {
            ...mapActions([     'fetchCollege']),

            ...mapMutations([   'updateSearchResultSidebar',
                                'updateSelectionCentering',  
                                'updateMainSidebar',
                                'setSearchResults',
                                'setSearchTitle',
                                'setSearchSubtitle',
                                'setSearchSort',
                                'setSelectedRoom',
                                'setLoading',
                                'unSetLoading',
                                'setSnackText',
                                'clearSearch',
                                'setSearchExportText',
                            ]),

            changeHandler (value) { 
                if (value) {                
                    this.submitSearch(value.id)
                }
            },
            
            submitSearch(value) {
                this.clearSearch()
                this.setLoading("college")
                this.setSnackText("College Searches can take some extra time.")
                this.fetchCollege(value).then((data) => {

                    if (data.departments) { data.sites = data.departments } // Hack to have Departments use existing control

                    if (data == "No Rows Found") {
                        console.log("No Rows Found on Dept Search")
                        this.setSnackText("No Data Found")
                        this.unSetLoading()
                        return
                    }

                    const subtitle =    `<div style="background-color: #383838;color: white;padding: 25px;margin-left: -25px;margin-top: -25px;">
                                                    <div class="headline">${data.collegeName}</div>
                                                    <div style="margin-bottom: 10px;">${data.collegeID}</div>
                                                    <div>Total Area: ${data.areaSum.toLocaleString()} ${data.borrowedAreaSum > 0 ? '(includes ' + data.borrowedAreaSum.toLocaleString() + ' borrowed)' : '' }</div>
                                                    <div>Bldg Count: ${data.bldgCount}</div>
                                                    <div>Room Count: ${data.roomCount}</div>
                                            `
                    this.setSearchResults(data)
                    this.setSearchTitle("College Search")
                    this.setSearchSubtitle(subtitle)
                    this.setSearchExportText(data.collegeName + " - " + data.collegeID)
                    this.setSearchSort("bldgAlpha")
                    this.updateMainSidebar(false)          
                    this.updateSearchResultSidebar(true)
                    this.unSetLoading()
                })
            },
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/search/SearchCollege.vue